import { useState, useEffect } from "react";
import { useProfile } from "../context/contextProfile";
import styled, { keyframes } from "styled-components";
import useDeviceDetect from "../utils/deviceDetect";

const fadeInAnimation = keyframes`from {opacity: 0;} to {opacity: 1;}`;
export const FadingComponent = styled.div`
  animation: ${fadeInAnimation} 0.3s ease-in-out;
`;

const useDesign = () => {
  const {
    sidebarExtended,
    setSidebarExtended,
    showProfileCard,
    setShowProfileCard,
    showUpgradeCard,
    setShowUpgradeCard,
    showEpssCard,
    setShowEpssCard,
  } = useProfile();
  const {
    isMobile, 
    isTablet, 
    isDesktop, 
    isMidDesktop, 
    isLargeDesktop 
  } = useDeviceDetect();
  const [zoom, setZoom] = useState(1);
  const [extendedVal, setExtendedVal] = useState(270);
  const [nonExtendedVal, setNonExtendedVal] = useState(100);
  const [sidebarWidthVal, setSidebarWidthVal] = useState(0);
  const [navbarHeightVal, setNavbarHeightVal] = useState(64);
  const [bWidthVal, setBWidthVal] = useState(0);
  const [bHeightVal, setBHeightVal] = useState(0);
  const [fontSizeVal, setFontSizeVal] = useState(0);

  const toggleSidebar = () => setSidebarExtended(!sidebarExtended);
  const toggleProfileCard = () => setShowProfileCard(!showProfileCard);
  const toggleUpgradeCard = () => setShowUpgradeCard(!showUpgradeCard);
  const toggleEpssCard = () => setShowEpssCard(!showEpssCard);

  useEffect(() => {
    setSidebarWidthVal(sidebarExtended ? extendedVal : nonExtendedVal);
  }, [sidebarExtended]);

  useEffect(() => {
    setNavbarHeightVal(64);
  }, []);

  useEffect(() => {
    setBWidthVal(`calc(100vw - ${sidebarWidthVal}px)`);
  }, [sidebarWidthVal]);

  useEffect(() => {
    setBHeightVal('80vh');
  }, []);

  useEffect(() => {
    setFontSizeVal(isMobile
      ? "12px": isTablet
      ? "13px": isDesktop
      ? "14px": isMidDesktop
      ? "15px": isLargeDesktop
      ? "16px": "clamp(15px, 0.8vw, 16px)");
  }, [isMobile, isTablet, isDesktop, isMidDesktop, isLargeDesktop]);  

  useEffect(() => {
    if (isMobile) {
      setZoom(0.7);
    } else if (isTablet) {
      setZoom(0.75);
    } else if (isMidDesktop) {
      setZoom(0.8);
    } else if (isDesktop) {
      setZoom(0.9);
    } else if (isLargeDesktop) {
      setZoom(1);
    }
  }, [isMobile, isTablet, isDesktop, isMidDesktop, isLargeDesktop]);

  const resetState = () => {
    setZoom(1);
    setExtendedVal(270);
    setNonExtendedVal(100);
    setSidebarWidthVal(0);
    setNavbarHeightVal(64);
    setBWidthVal(0);
    setBHeightVal(0);
    setFontSizeVal(0);
  };

  return {
    zoom, setZoom,
    sidebarWidthVal, setSidebarWidthVal,
    extendedVal, setExtendedVal,
    nonExtendedVal, setNonExtendedVal,
    fontSizeVal, setFontSizeVal,
    bWidthVal, setBWidthVal,
    bHeightVal, setBHeightVal,
    navbarHeightVal, setNavbarHeightVal,
    toggleSidebar,
    toggleProfileCard,
    toggleUpgradeCard,
    toggleEpssCard,
    FadingComponent,
    resetState
  };
};

export default useDesign;
